// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-center{
  display: flex;
  align-items: center;
  justify-content: center;
}
.app__header {
  background-color: #ffffff;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  font-size: calc(10px + 2vmin);
  color: #282c34;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.17);
  z-index: 999;
}

.app__header-transparent {
  /* background: rgba(0,0,0,0.65); */
  background: rgba(0,0,0);
  min-height: 60px;
  display: flex;
  font-size: calc(10px + 2vmin);
  color: #ffffff;
  box-shadow: 0px 2px 10px rgba(0,0,0,0.05);
}
.app__body {
  background-color: #3e4450;
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}
.main-container{
  width: 100%;
  height: 100%;
}
.card{
  width: 20%;
  height: 30vh;
  position: relative;
  background-color: whitesmoke;
  color: #282c34;
}
.app__link {
  color: #674bce;
}
.header_button {
  height: 38px;
  margin-top: 10px;
}
.navTabBar {
  height: 60px;
  flex-grow: 1;
  /* padding-left: 118px; */
  /* padding-right: 28px; */
  /* padding-left: 12px; */
}
.navTabBar_Landing {
  height: 60px;
  flex-grow: 1;
  /* padding-right: 28px; */
  padding-right: 134px;
  padding-left: 0;
}
.navTab {
  text-transform: capitalize;
  padding: 0;
  min-height: 60px;
  min-width: 100px;
  @media screen and (max-width: 600px) {
    min-width: 19vw;
  }
}
.MuiStepLabel-active {
  background: white;
}
.primary {
  background-color: #5BC2A8;
  color: #ffffff;
}
.primaryDark {
  background-color: #14967B;
}
.primaryLight {
  color: #0b6c53;
  background-color: #d5f7ee;
}
.primaryLight2{
  color: #0b6c53;
  background-color: #d8d8d8;
}
.primaryText {
  color: #5BC2A8;
}
.defaultTextLight {
  color: #cbcbcb
}
  `, "",{"version":3,"sources":["webpack://./src/style/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB;IACE,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE;AACF","sourcesContent":[".flex-center{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.app__header {\n  background-color: #ffffff;\n  min-height: 60px;\n  display: flex;\n  flex-direction: column;\n  font-size: calc(10px + 2vmin);\n  color: #282c34;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.17);\n  z-index: 999;\n}\n\n.app__header-transparent {\n  /* background: rgba(0,0,0,0.65); */\n  background: rgba(0,0,0);\n  min-height: 60px;\n  display: flex;\n  font-size: calc(10px + 2vmin);\n  color: #ffffff;\n  box-shadow: 0px 2px 10px rgba(0,0,0,0.05);\n}\n.app__body {\n  background-color: #3e4450;\n  min-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n.main-container{\n  width: 100%;\n  height: 100%;\n}\n.card{\n  width: 20%;\n  height: 30vh;\n  position: relative;\n  background-color: whitesmoke;\n  color: #282c34;\n}\n.app__link {\n  color: #674bce;\n}\n.header_button {\n  height: 38px;\n  margin-top: 10px;\n}\n.navTabBar {\n  height: 60px;\n  flex-grow: 1;\n  /* padding-left: 118px; */\n  /* padding-right: 28px; */\n  /* padding-left: 12px; */\n}\n.navTabBar_Landing {\n  height: 60px;\n  flex-grow: 1;\n  /* padding-right: 28px; */\n  padding-right: 134px;\n  padding-left: 0;\n}\n.navTab {\n  text-transform: capitalize;\n  padding: 0;\n  min-height: 60px;\n  min-width: 100px;\n  @media screen and (max-width: 600px) {\n    min-width: 19vw;\n  }\n}\n.MuiStepLabel-active {\n  background: white;\n}\n.primary {\n  background-color: #5BC2A8;\n  color: #ffffff;\n}\n.primaryDark {\n  background-color: #14967B;\n}\n.primaryLight {\n  color: #0b6c53;\n  background-color: #d5f7ee;\n}\n.primaryLight2{\n  color: #0b6c53;\n  background-color: #d8d8d8;\n}\n.primaryText {\n  color: #5BC2A8;\n}\n.defaultTextLight {\n  color: #cbcbcb\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
